module.exports = __webpack_public_path__ + "img/607.a08cb878.jpg";